module.exports = __webpack_public_path__ + "static/img/call-pass.4a6d1998.png";